export default __webpack_public_path__ + "static/media/javascript.f99730b4.svg";